import exploreSubjectUnitCardEn from "./locales/en.json";

export const EXPLORE_SUBJECT_UNIT_CARD_NS = "exploreSubjectUnitCard" as const;

export const ExploreSubjectUnitCardTranslations = {
  en: {
    [EXPLORE_SUBJECT_UNIT_CARD_NS]: {
      ...exploreSubjectUnitCardEn,
    },
  },
};
